import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var PageHeaderTabs = /*#__PURE__*/function (_Component) {
  function PageHeaderTabs() {
    _classCallCheck(this, PageHeaderTabs);

    return _callSuper(this, PageHeaderTabs, arguments);
  }

  _inherits(PageHeaderTabs, _Component);

  return _createClass(PageHeaderTabs, [{
    key: "render",
    value: function render() {
      var headerTabs = this.props.headerTabs;
      return /*#__PURE__*/React.createElement("div", {
        className: "header-tabs"
      }, headerTabs);
    }
  }]);
}(Component);

_defineProperty(PageHeaderTabs, "propTypes", {
  headerTabs: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
});

PageHeaderTabs.displayName = "PageHeaderTabs";
export { PageHeaderTabs };